<template>
  <v-container class="approval-requests-container">
    <v-layout>
      <v-flex
        style="text-align: start;"
      >
        <v-btn
          flat
          icon
          block
          color="primary"
          class="back-btn ma-0 mb-4"
          @click="goBack()"
        >
          <v-icon class="mr-2">
            $vuetify.icons.arrowLeftIcon
          </v-icon>
          Voltar
        </v-btn>
      </v-flex>
    </v-layout>
    <span class="d-block mb-4">
      <TitleChip title="Solicitações" />
    </span>
    <v-layout
      v-if="getPendingApprovalRequests.length"
      column
    >
      <v-flex
        v-for="approvalRequest in getPendingApprovalRequests"
        :key="approvalRequest._id"
      >
        <ApprovalRequestCard :approval-request="approvalRequest" />
      </v-flex>
    </v-layout>
    <v-layout
      v-else
      justify-center
      align-center
      style="height: 40vh;"
    >
      <v-flex xs10>
        <span class="no-approval-requests-message">
          Não há solicitações para você no momento ;)
        </span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getPendingApprovalRequests']),
  },
  methods: {
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss">
.approval-requests-container {
  padding: 24px 24px 80px;
}

.no-approval-requests-message {
  display: block;
  font: 400 24px/33px 'Nunito Sans';
  text-align: center;
}

.back-btn {
  font: 400 14px/102% 'Neue-Metana';
  text-transform: capitalize;
  width: fit-content;
  border-radius: 20px;
}
</style>
